import React from "react";
import { Flex, Text, VerticalDivider } from "@100mslive/roomkit-react";
import { ScreeningContext } from "../../context/ScreeningContext";
import { SpeakerTag } from "./HeaderComponents";
import { StreamActions } from "./StreamActions";

export const ConferencingHeader = ({ isPreview }) => {
  const { screeningData } = React.useContext(ScreeningContext);
  return (
    <Flex
      justify="between"
      align="center"
      css={{ position: "relative", height: "100%" }}
    >
      {!isPreview ? (
        <Flex
          align="center"
          css={{
            position: "absolute",
            right: "$10",
            gap: "$6",
          }}
        >
          <StreamActions />
        </Flex>
      ) : null}
    </Flex>
  );
};
